import * as React from 'react'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import { Product } from 'src/resources'
import ProductBox from 'src/components/containers/configurator/ProductBox'
import Checkmark from 'src/components/atoms/input/Checkmark'
import MoreInfo from 'src/components/atoms/input/buttons/MoreInfo'
import { StoreProps } from 'src/stores'
import CustomModal from 'src/components/containers/CustomModal'
import { media } from 'src/utils.js'
import ReactHtmlParser from 'react-html-parser';

const NumberFormat = require('react-number-format')

interface Props extends StoreProps {
  product: Product
  hideImage?: boolean
  disabled?: boolean
  idLabel?: any
}

interface State {
  modal: boolean
  isChecked: boolean
}

@inject('confStore')
@observer
export default class ProductCardSmall extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    const { product } = this.props
    this.state = {
      modal: false,
      isChecked: this.hasProduct(product.uuid)
    }
  }

  hasProduct = (uuid) => {
    const { confStore } = this.props
    let hasProduct = false
    if (confStore.getOffer.products) {
      toJS(confStore.getOffer.products).forEach((product) => {
        if (product.uuid === uuid) hasProduct = true
      })
    }
    return hasProduct
  }

  handleClick = () => {
    const { confStore, product } = this.props
    const { isChecked } = this.state
    const checkmark = !isChecked
    // For simplification all small product cards have multiselect enabled
    confStore.toggleProduct(product, 1, true)
    this.setState({ isChecked: checkmark })
  }

  render() {
    const { disabled, product, hideImage, idLabel } = this.props
    const { modal } = this.state

    const variableStyle = {
      boxShadow: 'none',
      marginRight: '7.5px'
    }

    const price = product.prices[0].amount / 100
    const productBox = (
      <ProductBox disabled={disabled} stlye={variableStyle}>
        {!hideImage && <CardImage img={product.photos[0]} alt='product_pic' />}
        <DataContainer fullHeight={hideImage}>
          <ServiceName>{product.name}</ServiceName>
          <Price>
            {price === 0 ? (
              'Inkl.'
            ) : (
              <NumberFormat
                value={price}
                displayType='text'
                thousandSeparator='.'
                decimalSeparator=','
                prefix='€ '
                decimalScale={2}
                fixedDecimalScale={!Number.isInteger(+price)}
              />
            )}
          </Price>
          {!disabled && (
            <MoreInfo onClick={() => this.setState({ modal: true })} />
          )}
          {!disabled && (
            <Checkmark
              onClick={() => this.handleClick()}
              checked={this.hasProduct(product.uuid)}
              id={idLabel}>
              <p>Auswählen</p>
            </Checkmark>
          )}
        </DataContainer>
      </ProductBox>
    )

    return (
      <div>
        <CustomModal
          title={product.name}
          onClose={() => this.setState({ modal: false })}
          open={modal}>
          <div>{product.shortDescription}</div>
          <div className='product-long-desc' style={{ textAlign: 'left' }}>
            {ReactHtmlParser(product.longDescription)}
          </div>
        </CustomModal>
        {productBox}
      </div>
    )
  }
}

const DataContainer = styled.div`
  position: relative;
  height: ${(props) => (props.fullHeight ? '100%' : '50%')};
  width: 100%;
  padding: 15px;
  padding-bottom: 45px;
`

const CardImage = styled.div`
  width: 100%;
  height: 50%;
  min-height: 150px;
  background-image: url(${(props) => props.img});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

// min height here is required so that
// cards that have a one line service name
// are not shorter than the ones with two lines
const ServiceName = styled.p`
  min-height: 56px;
  font-size: 18px;
  font-weight: 700;
  display: inline-block;
  margin: 0px;
  ${media.tablet` font-size: 16px; `}
`

const Price = styled.p`
  margin: 10px 0;
  font-size: 18px;
  font-weight: 700;
  color: #4a4a4a;
  overflow: hidden;
  white-space: nowrap;
  ${media.tablet` font-size: 16px; `}
`



// WEBPACK FOOTER //
// ./src/components/molecules/configurator/ProductCardSmall.tsx